import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Nav from "../components/Nav";
import SidebarTareas from "../components/SidebarTareas";
import { collection, onSnapshot, doc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useNavContext } from "../context/NavContext";
import { useTaskContext } from "../context/TaskContext";
import TaskBoard from "../components/TaskBoard";
import CreateTaskModal from "../components/CreateTaskModal";
import CreateListModal from "../components/CreateListModal";
import TaskDetailModal from "../components/TaskDetailModal";
import AttachModal from "../components/AttachModal";
import Swal from "sweetalert2";
import Avatar from "../components/Avatar";
import { useFunctionsPrevia } from "../hooks/useFunctionsPrevia";

Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    width: "30%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
    fontFamily: "Montserrat, sans-serif",
    "::WebkitScrollbar": {
      width: "0px",
      background: "transparent",
    },
    /* Ocultar scrollbar en IE y Edge */
    msOverflowStyle: "none",
    /* Ocultar scrollbar en Firefox */
    scrollbarWidth: "none",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 101,
  },
  title: {
    textAlign: "center",
  },
  input: {
    width: "85%",
    padding: "8px",
    margin: "0 auto",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
    display: "flex",
    marginTop: "10px",
    marginBottom: "10px",
  },
  buttonAgregar: {
    padding: "10px 20px",
    margin: "10px",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "#007bff",
    color: "white",
    fontSize: "14px",
    cursor: "pointer",
    position: "absolute",
    top: "10px",
    left: "60px",
  },
  button: {
    padding: "10px 20px",
    margin: "10px 5px",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "#007bff",
    color: "white",
    fontSize: "14px",
    cursor: "pointer",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
  },
  taskItem: {
    position: "relative",
    padding: "10px",
    borderBottom: "1px solid #ccc",
    marginBottom: "10px",
    borderRadius: "5px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  taskDetails: {
    display: "flex",
    flexDirection: "column",
  },
  taskOptions: {
    position: "absolute",
    top: "10px",
    right: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  select: {
    display: "none",
    marginTop: "5px",
    padding: "5px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    fontFamily: "Montserrat, sans-serif",
    backgroundColor: "#fff",
    position: "absolute",
    top: "25px",
    right: "0",
  },
  selectVisible: {
    display: "block",
  },
};

const boxStyle = {
  marginTop: 30,
  border: "1px solid #E6EDFF",
  borderRadius: 6,
  padding: "24px 12px",
  minHeight: 440,
  boxSizing: "border-box",
};

// Texto gris “Crea una lista...”
const emptyStyle = {
  fontSize: "18px",
  color: "#888",
  textAlign: "center",
  marginTop: "100px",
};

// Imagen de “sin datos”
const emptyImageStyle = {
  display: "block",
  margin: "20px auto",
  width: "300px",
  height: "220px",
  opacity: 0.7,
};

const customStyles2 = {
  content: {
    top: "50%",
    left: "50%",
    width: "50%",
    maxWidth: "600px",
    maxHeight: "80%",
    transform: "translate(-50%, -50%)",
    overflowY: "auto",
    padding: "40px",
    borderRadius: "10px",
    border: "none",
    background: "#ffffff",
    position: "relative",
    boxShadow: "0 10px 50px rgba(0, 0, 0, 0.2)",
    fontFamily: "Roboto, sans-serif",
    "::WebkitScrollbar": {
      width: "0px",
      background: "transparent",
    },
    /* Ocultar scrollbar en IE y Edge */
    msOverflowStyle: "none",
    /* Ocultar scrollbar en Firefox */
    scrollbarWidth: "none",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    zIndex: 101,
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    marginBottom: "20px",
  },
  label: {
    display: "flex",
    flexDirection: "column",
    fontSize: "16px",
    color: "#333",
    marginBottom: "5px",
  },
  input: {
    width: "100%",
    padding: "10px",
    fontSize: "16px",
    marginTop: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  inputColor: {
    appearance: "none",
    border: "1px solid #ccc",
    height: "35px",
    width: "100%",
    borderRadius: "5px",
    cursor: "pointer",
    padding: "0",
    transition: "box-shadow 0.3s ease",
    marginTop: "10px",
  },
  addButton: {
    padding: "15px",
    borderRadius: "10px",
    border: "none",
    backgroundColor: "#007bff",
    color: "#ffffff",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s, transform 0.2s",
  },
};

function Tareas() {
  const { searchTerm, proximasAVencer, proximosEventos } = useNavContext();
  const { listsGlobal, tasksGlobal, listColors, groupsGlobal, deleteList } =
    useTaskContext();

  const [usersList, setUsersList] = useState([]);
  const [groups, setGroups] = useState([]); // Si lo manejas en TaskContext, ajusta
  const [selectedProject, setSelectedProject] = useState(null);
  const [isEditingProjectName, setIsEditingProjectName] = useState(false);
  const [tempProjectName, setTempProjectName] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [zoomLevel, setZoomLevel] = useState(1);
  const [isActivePlus, setIsActivePlus] = useState(false);
  const [isActiveDash, setIsActiveDash] = useState(false);
  const [isListModalOpen, setIsListModalOpen] = useState(false);
  const [listToEdit, setListToEdit] = useState(null);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [taskToEdit, setTaskToEdit] = useState(null);
  const [currentList, setCurrentList] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [isAttachModalOpen, setIsAttachModalOpen] = useState(false);
  const { formatDate } = useFunctionsPrevia();

  useEffect(() => {
    setGroups(groupsGlobal);
  }, [groupsGlobal]);

  useEffect(() => {
    if (!selectedProject && groups.length > 0) {
      // Extraemos todos los proyectos de todos los grupos
      const allProjects = groups.reduce((acc, group) => {
        const projects = group.projects || [];
        // Agregamos la referencia del grupo a cada proyecto
        return acc.concat(
          projects.map((proj) => ({ ...proj, groupId: group.id }))
        );
      }, []);
      if (allProjects.length > 0) {
        // Ordenamos los proyectos por fecha de creación descendente
        allProjects.sort(
          (a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0)
        );
        // Seleccionamos el primer proyecto (el último creado)
        setSelectedProject(allProjects[0]);
      }
    }
  }, [groups, selectedProject]);

  useEffect(() => {
    // Ejemplo: cargar usuarios de Firestore
    const unsub = onSnapshot(collection(db, "usuarios"), (snapshot) => {
      const arr = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsersList(arr);
    });
    return () => unsub();
  }, []);

  const handleAttachmentsUpdated = (updatedAttachments) => {
    setSelectedTask((prev) =>
      prev ? { ...prev, attachments: updatedAttachments } : prev
    );
  };

  const pastelColors = [
    "#FBE6FC", // Rosa
    "#D9F4F8", // Azul claro
    "#FFECE1", // Naranja suave
    "#E1F6FF", // Azul distinto
    "#6ae88e", // Verde claro
  ];

  const tagTextColors = [
    "#FF00B8", // Texto Rosa
    "#268FB0", // Texto Azul claro
    "#FF5C00", // Texto Naranja
    "#2C62B4", // Texto Azul distinto
    "#038554", // Texto Verde
  ];

  const assignedUsers = Array.isArray(selectedProject?.assignedTo)
    ? selectedProject.assignedTo
    : [];
  const tagsArray = Array.isArray(selectedProject?.tags)
    ? selectedProject.tags
    : [];

  // Zoom
  const handleZoomChange = (val) => {
    const level = Math.max(1, Math.min(4, val));
    setZoomLevel(level);
  };
  const increaseZoom = () => {
    if (zoomLevel < 4) {
      handleZoomChange(zoomLevel + 1);
      setIsActivePlus(true);
      setTimeout(() => setIsActivePlus(false), 200);
    }
  };
  const decreaseZoom = () => {
    if (zoomLevel > 1) {
      handleZoomChange(zoomLevel - 1);
      setIsActiveDash(true);
      setTimeout(() => setIsActiveDash(false), 200);
    }
  };

  // Filtrar listas/tareas por projectId
  const projectLists = selectedProject
    ? listsGlobal.filter((l) => l.projectId === selectedProject.id)
    : [];
  const projectTasks = selectedProject
    ? tasksGlobal.filter((t) => t.projectId === selectedProject.id)
    : [];

  // Filtro busqueda
  const filteredTasks = searchInput
    ? projectTasks.filter((t) =>
        t.title.toLowerCase().includes(searchInput.toLowerCase())
      )
    : projectTasks;

  // Edición de nombre de proyecto
  const handleEditProjectNameClick = () => {
    if (!selectedProject) return;
    setIsEditingProjectName(true);
    setTempProjectName(selectedProject.projectName || "");
  };

  const handleSaveProjectName = async () => {
    if (!selectedProject) return;
    try {
      // Referencia al documento del proyecto en Firestore (asegúrate de que selectedProject.groupId y selectedProject.id existan)
      const projectDocRef = doc(
        db,
        "gruposTareas",
        selectedProject.groupId,
        "projects",
        selectedProject.id
      );
      // Actualiza el campo projectName en Firestore
      await updateDoc(projectDocRef, { projectName: tempProjectName });

      // Actualiza el estado local del proyecto para que se refleje de inmediato
      setSelectedProject((prev) =>
        prev ? { ...prev, projectName: tempProjectName } : prev
      );

      // Actualiza también el estado global de grupos (o el que uses en el Sidebar)
      setGroups((prevGroups) =>
        prevGroups.map((group) =>
          group.id === selectedProject.groupId
            ? {
                ...group,
                projects: group.projects.map((proj) =>
                  proj.id === selectedProject.id
                    ? { ...proj, projectName: tempProjectName }
                    : proj
                ),
              }
            : group
        )
      );

      setIsEditingProjectName(false);
      Swal.fire({
        title: "Proyecto actualizado",
        text: "El nombre del proyecto se cambio correctamente",
        icon: "success",
        scrollbarPadding: false,
      });
    } catch (error) {
      console.error("Error al actualizar el proyecto:", error);
      Swal.fire({
        title: "Error",
        text: "No se pudo actualizar el nombre del proyecto",
        icon: "error",
        scrollbarPadding: false,
      });
    }
  };

  // Manejo List Modal
  const openNewListModal = (obj = null) => {
    setListToEdit(obj); // { name, color } si es edición
    setIsListModalOpen(true);
  };
  const closeNewListModal = () => {
    setIsListModalOpen(false);
  };
  const handleDeleteListClick = async (listName) => {
    if (!selectedProject) return;
    await deleteList(listName, selectedProject.id);
  };

  // Manejo Task Modal
  const openTaskModal = (listName, task = null) => {
    setCurrentList(listName);
    setTaskToEdit(task);
    setIsTaskModalOpen(true);
  };
  const closeTaskModal = () => {
    setTaskToEdit(null);
    setCurrentList(null);
    setIsTaskModalOpen(false);
  };

  // Manejo Task Detail
  const openDetailModal = (t) => {
    setSelectedTask(t);
    setIsDetailModalOpen(true);
  };
  const closeDetailModal = () => {
    setSelectedTask(null);
    setIsDetailModalOpen(false);
  };

  // Manejo Attach
  const openAttachModal = (t) => {
    setSelectedTask(t);
    setIsAttachModalOpen(true);
  };
  const closeAttachModal = () => {
    setSelectedTask(null);
    setIsAttachModalOpen(false);
  };

  const uniqueAssigned = Array.from(
    new Map(assignedUsers.map((u) => [u.id, u])).values()
  );

  return (
    <>
      <Nav
        handleSearch={searchTerm}
        proximasAVencer={proximasAVencer}
        proximosEventos={proximosEventos}
      />
      <div className="tareas-layout">
        {/* Sidebar con grupos y proyectos */}
        <SidebarTareas
          groups={groups}
          setGroups={setGroups} // si necesitas actualizar local
          onSelectProject={setSelectedProject}
          usuarios={usersList}
        />

        <div className="tareas-content">
          {/* Header de proyecto exacto */}
          {selectedProject && (
            <div className="project-header">
              <div className="header-top-row">
                <h2 className="project-title">
                  {isEditingProjectName ? (
                    <input
                      type="text"
                      value={tempProjectName}
                      onChange={(e) => setTempProjectName(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSaveProjectName();
                      }}
                      autoFocus
                      style={{
                        fontSize: "20px",
                        border: "none",
                        outline: "none",
                        background: "transparent",
                      }}
                    />
                  ) : (
                    <>
                      {selectedProject.projectName}{" "}
                      <i
                        className="bi bi-pencil"
                        style={{
                          color: "#B8BFCC",
                          marginLeft: "5px",
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                        onClick={handleEditProjectNameClick}
                      ></i>
                    </>
                  )}
                </h2>

                <button
                  className="new-task-button"
                  onClick={() => openNewListModal(null)}
                >
                  <i className="bi bi-plus"></i> Agregar
                </button>
              </div>

              <div className="header-bottom-row">
                <div className="info-left">
                  <div className="info-item">
                    <span className="label">Visibilidad:</span>
                    <span className="value">
                      <i
                        className="bi bi-lock-fill"
                        style={{ marginRight: "5px" }}
                      ></i>
                      {selectedProject.visibility || "Solo etiquetados"}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Asignado a:</span>
                    <div className="avatares-group">
                      {uniqueAssigned.length > 0 ? (
                        <>
                          {uniqueAssigned.slice(0, 4).map((u) => (
                            <Avatar
                              key={u.id}
                              userId={u.id} // <-- el UID real
                              size={32}
                              className="avatarTarea"
                            />
                          ))}
                          {assignedUsers.length > 4 && (
                            <span className="avatares-count">
                              +{assignedUsers.length - 4}
                            </span>
                          )}
                        </>
                      ) : (
                        <>
                          <img src="/img/avatar2.jpg" alt="avatar1" />
                          <img src="/img/avatar2.jpg" alt="avatar2" />
                          <img src="/img/avatar2.jpg" alt="avatar3" />
                          <span className="avatares-count">+5</span>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="info-item">
                    <span className="label">Fecha:</span>
                    <span className="value">
                      {selectedProject.date
                        ? formatDate(selectedProject.date)
                        : "15 mar 2025"}{" "}
                      <i
                        className="bi bi-chevron-down"
                        style={{ marginLeft: "5px" }}
                      ></i>
                    </span>
                  </div>

                  <div className="info-item">
                    <span className="label">Etiquetas:</span>
                    {tagsArray.length > 0 ? (
                      tagsArray.map((tag, idx) => (
                        <span
                          key={idx}
                          style={{
                            display: "inline-block",
                            marginRight: "5px",
                            marginBottom: "5px",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            fontWeight: "bold",
                            fontSize: "13px",
                            backgroundColor:
                              pastelColors[idx % pastelColors.length],
                            color: tagTextColors[idx % tagTextColors.length],
                          }}
                        >
                          {tag}
                        </span>
                      ))
                    ) : (
                      <span className="tag">Sin etiquetas</span>
                    )}
                  </div>
                </div>

                <div className="controls-right">
                  <div className="buscador-pedidos">
                    <i className="bi bi-search"></i>
                    <input
                      type="text"
                      className="buscador-input"
                      placeholder="Buscar Tareas..."
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                    />
                  </div>

                  <div className="zoom-container">
                    <button
                      onClick={decreaseZoom}
                      className={`zoom-dot ${zoomLevel === 1 ? "active" : ""} ${
                        isActiveDash ? "clicked" : ""
                      }`}
                    >
                      <i className="bi bi-dash"></i>
                    </button>
                    <input
                      type="range"
                      min="1"
                      max="4"
                      value={zoomLevel}
                      onChange={(e) =>
                        handleZoomChange(parseInt(e.target.value))
                      }
                      className="zoom-slider"
                    />
                    <button
                      onClick={increaseZoom}
                      className={`zoom-dot ${zoomLevel === 4 ? "active" : ""} ${
                        isActivePlus ? "clicked" : ""
                      }`}
                    >
                      <i className="bi bi-plus"></i>
                    </button>
                  </div>

                  <div className="view-toggle">
                    <button className="view-toggle-btn active">
                      <i className="bi bi-grid"></i> Cuadrícula
                    </button>
                    <button className="view-toggle-btn">
                      <i className="bi bi-list"></i> Lista
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* El tablero Kanban */}
          {selectedProject && (
            <div style={boxStyle}>
              {projectLists.length === 0 ? (
                <>
                  <p style={emptyStyle}>
                    Crea una lista para empezar a organizar tus tareas.
                  </p>
                  <img
                    src="/img/no-data.svg"
                    alt="Sin listas"
                    style={emptyImageStyle}
                  />
                </>
              ) : (
                <TaskBoard
                  selectedProject={selectedProject}
                  projectLists={projectLists}
                  projectTasks={filteredTasks}
                  listColors={listColors}
                  zoomLevel={zoomLevel}
                  openNewListModal={openNewListModal}
                  handleDeleteListClick={handleDeleteListClick}
                  openTaskModal={openTaskModal}
                  openDetailModal={openDetailModal}
                  openAttachModal={openAttachModal}
                />
              )}
            </div>
          )}
        </div>
      </div>

      {/* Modal Crear/Editar Lista */}
      {isListModalOpen && (
        <CreateListModal
          isOpen={isListModalOpen}
          onRequestClose={closeNewListModal}
          listToEdit={listToEdit}
          projectId={selectedProject?.id}
          customStyles2={customStyles2}
        />
      )}

      {/* Modal Crear/Editar Tarea */}
      {isTaskModalOpen && (
        <CreateTaskModal
          isOpen={isTaskModalOpen}
          onRequestClose={closeTaskModal}
          taskToEdit={taskToEdit}
          listName={currentList}
          projectId={selectedProject?.id}
          customStyles={customStyles}
          usuarios={usersList}
        />
      )}

      {/* Modal Detalle de Tarea */}
      {isDetailModalOpen && (
        <TaskDetailModal
          isOpen={isDetailModalOpen}
          onRequestClose={closeDetailModal}
          selectedTask={selectedTask}
          customStyles2={customStyles2}
        />
      )}

      {/* Modal Adjuntos */}
      {isAttachModalOpen && (
        <AttachModal
          isOpen={isAttachModalOpen}
          onRequestClose={closeAttachModal}
          selectedTask={selectedTask}
          customStyles2={customStyles2}
          onAttachmentsUpdated={handleAttachmentsUpdated}
        />
      )}
    </>
  );
}

export default Tareas;
